module.exports = __webpack_public_path__ + "assets/img/算法分批2.0a50291b.jpg";